import React, { useState } from 'react';
import styles from './DashboardPageAppMfg.module.css';
import { useSelector } from 'react-redux';
import { Avatar, Paper } from '@mui/material';
import IconStatCard from 'CommonComponents/IconStatCard';
import { getAnalyticSummaryPageData } from 'Redux/DashboardVariables';
import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong';
import { StyledTabs } from 'CommonComponents/StyledTabs';
import { StyledTab } from 'CommonComponents/StyledTabs';
import { a11yProps } from 'CommonComponents/StyledTabs';
import AllChartsComponents from './AllChartsComponent';

const AnalyticsSummaryAHF = () => {
  const {
    boxesPacked,
    fillErrors,
    boxFillOK,
    underFillBoxes,
    overFillBoxes,
    boxFillOkPercentage,
    underFillPercentage,
    overFillPercentage,
    qualityDistributionData
  } = useSelector(getAnalyticSummaryPageData);

  // console.log('machine up down data: ', machineUpdownData);

  const [tabValue, setTabValue] = useState(0);

  const handleChangeTabs = (event, newValue) => {
    setTabValue(newValue);
  };

  let displayAvatar = (bgcolor, icon) => {
    return (
      <Avatar sx={{ bgcolor: bgcolor }} aria-label="recipe">
        {icon}
      </Avatar>
    );
  }

  const DisplayCard = (useCase) => {
    return (
      <Paper
        key={useCase.title}
        elevation={0}
        style={{
          background: "transparent",
          width: "50%",
          padding: '2px 1px',
          boxSizing: 'border-box',
        }}
      >
        <IconStatCard
          title={useCase.title}
          subheader={useCase.subheader}
          body={useCase.body}
          footer={useCase.footer}
          cardStyle={{ height: '100%', boxShadow: 'none' }}
          headerStyle={{ textAlign: 'left' }}
          avatar={useCase.avatar}
          footerButtonOnClick={useCase.footerButtonOnClick}
        />
      </Paper>
    );
  }

  // console.log('main log analytic summary ge: ', videoData);

  return (
    <>
      <div className={styles.topContainer}>
        <div className={styles.leftColumnContainer} style={{ paddingLeft: "0px" }}>
          <div style={{ width: "100%" }}>
            <Paper elevation={0} style={{
              overflow: 'hidden',
              padding: '10px 10px',
              fontSize: "12px",
              color: "#757575",
              marginBottom: '2px'
            }}>
              <div style={{ display: 'flex' }}>
                <div style={{
                  width: "100%",
                  fontFamily: 'Lato, sans-serif',
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center'
                }}>
                  Key Analytics
                </div>
              </div>
            </Paper>
          </div>
          <div style={{ display: 'flex' }}>
            <div className={styles.topContainerDashboard} style={{ margin: "0px 0px 0px 0px", display: "flex", flexWrap: "wrap" }}>
              {DisplayCard({
                avatar: displayAvatar('#00695C', <CenterFocusStrongIcon />),
                title: 'Boxes Packed', body: boxesPacked, footer: 'Total'
              })}
              {DisplayCard({
                avatar: displayAvatar('#B71C1C', <CenterFocusStrongIcon />),
                title: 'Fill Errors', body: fillErrors
              })}
              {DisplayCard({
                avatar:
                  displayAvatar('#00695C', <CenterFocusStrongIcon />),
                title: 'Box Fill Ok', body: boxFillOK, footer: 'Total'
              })}
              {DisplayCard({
                avatar:
                  displayAvatar('#00695C', <CenterFocusStrongIcon />),
                title: 'Box Fill Ok %', body: `${boxFillOkPercentage}%`
              })}
              {DisplayCard({
                avatar:
                  displayAvatar('#B71C1C', <CenterFocusStrongIcon />),
                title: 'Underfill Boxes', body: underFillBoxes, footer: 'Total'
              })}
              {DisplayCard({
                avatar:
                  displayAvatar('#B71C1C', <CenterFocusStrongIcon />),
                title: 'Underfill %', body: `${underFillPercentage}%`,
              })}
              {DisplayCard({
                avatar:
                  displayAvatar('#B71C1C', <CenterFocusStrongIcon />),
                title: 'Overfill Boxes', body: overFillBoxes, footer: 'Total Duration'
              })}
              {DisplayCard({
                avatar:
                  displayAvatar('#B71C1C', <CenterFocusStrongIcon />),
                title: 'Overfill %', body: `${overFillPercentage}%`, footer: ' '
              })}
            </div>
          </div>
        </div>
        <div className={styles.rightColumnContainer}>
          <Paper elevation={0} style={{
            overflow: 'hidden',
            padding: '10px 10px',
            height: '100%',
            fontSize: "12px",
            color: "#757575",
          }}>
            <StyledTabs
              value={tabValue}
              onChange={handleChangeTabs}
              aria-label="styled tabs example"
            >
              <StyledTab label="Quality Distribution" {...a11yProps(0)} />
            </StyledTabs>
            {tabValue === 0 && <AllChartsComponents allChartsData={qualityDistributionData} />}
          </Paper>
        </div>
      </div>
    </>
  );
};


export default AnalyticsSummaryAHF;

